import { useMutation } from "@apollo/client";
import { Card } from "@blueprintjs/core";
import _ from "lodash";
import { RouteComponentProps } from "react-router-dom";
import { UpdateUserInput, User } from "../../../api/schema";
import {
  FlexCenter,
  FlexGrow,
  FlexRowStretch,
} from "../../../components/flex/Flex";
import { ModalInputType } from "../../../components/form/Form";
import {
  InputFormMode,
  ValuesVariables,
} from "../../../components/form/InputForm";
import {
  InputFormBuilder,
  FormInputFields,
} from "../../../components/form/InputFormBuilder";
import { UserLanguage } from "../../../lang/lang";
import { useApiUser } from "../../../store/Me";
import { useApiUsers } from "../../../store/Users";
import { IUserQuery, UpdateProfileMutation } from "../graphql";
import { Permissions, Roles } from "../ui/roles";

export const UpdateProfileKeys: FormInputFields<User> = {
  id: {
    type: ModalInputType.Display,
    label: UserLanguage().data.id,
  },
  username: {
    type: ModalInputType.String,
    label: UserLanguage().data.name,
  },
  displayname: {
    type: ModalInputType.String,
    label: UserLanguage().data.display_name,
  },
  email: {
    type: ModalInputType.String,
    label: UserLanguage().data.user.email,
  },
};

interface ProfileViewControllerProps {
  id?: string;
}

export const UserProfileViewController = (
  props: {} & RouteComponentProps<{ id: string }>
) => {
  const match = props.match;

  if (match && match.params.id && match.params.id.length > 0)
    return <ProfileView id={match.params.id} />;

  return <p>Error!</p>;
};

export const ProfileView = (props: ProfileViewControllerProps) => {
  const [update_profile] = useMutation<
    IUserQuery,
    ValuesVariables<UpdateUserInput>
  >(UpdateProfileMutation);

  const { refetch: refetch_profile, profile } = useApiUser();
  const { fetch_users, users } = useApiUsers();

  let user;
  let refetch;
  if (props.id) {
    console.log("users", users);
    const _find = _.find(users, { id: props.id }) as User | null;
    if (!_find) return <>Error!</>;
    user = _find;
    refetch = fetch_users;
  } else {
    user = profile.user;
    refetch = refetch_profile;
  }

  if (user === null || user === undefined) return <></>;

  return (
    <FlexCenter style={{ marginTop: "2em" }}>
      <Card elevation={3} style={{ display: "flex", gap: "2em" }}>
        <div>
          <h2>{UserLanguage().pages.profile.title}</h2>
          <InputFormBuilder<User>
            input={user}
            mode={InputFormMode.Edit}
            onSuccess={refetch}
            mutation={update_profile}
            keys={UpdateProfileKeys}
            texts={UserLanguage().pages.userlist.actions}
          >
            {(builder) => (
              <div>
                {builder.buildCards()}
                {builder.buildField("id")}
                {builder.buildField("username")}
                {builder.buildField("displayname")}
                {builder.buildField("email")}
                <FlexRowStretch>
                  <FlexGrow />
                  {builder.buildSubmitButton()}
                </FlexRowStretch>
              </div>
            )}
          </InputFormBuilder>
        </div>
        <div>
          <h2>Rollen</h2>
          <Roles roles={user.roles} />
          <h2>{UserLanguage().data.permissions.label}</h2>
          <Permissions permissions={user.permissions} />
        </div>
      </Card>
    </FlexCenter>
  );
};
